import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Activity, Clock3, RadioTower, Send, SlidersHorizontal } from 'lucide-react'

import { useInstancesStore } from '@/stores/instancesStore'
import '@/styles/monitoring.css'
import { TabNavigation } from './components/TabNavigation'
import { BufferTab } from './tabs/BufferTab'
import { DispatchTab } from './tabs/DispatchTab'
import { FollowUpTab } from './tabs/FollowUpTab'
import { RcsTab } from './tabs/RcsTab'

const TABS = [
  { key: 'buffer', label: 'Buffer Humanizado', icon: <SlidersHorizontal size={16} /> },
  { key: 'followup', label: 'Follow-up', icon: <Clock3 size={16} /> },
  { key: 'dispatch', label: 'Disparo em Massa', icon: <Send size={16} /> },
  { key: 'rcs', label: 'RCS', icon: <RadioTower size={16} /> },
]

const LS_KEY = 'monitoring-active-tab'

export default function MonitoringPage() {
  const { fetchInstances } = useInstancesStore()
  const [searchParams, setSearchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState<string>('buffer')

  const normalizedInitialTab = useMemo(() => {
    const tabParam = searchParams.get('tab')
    if (tabParam === 'personas' || tabParam === 'agents') return 'followup'
    if (tabParam && TABS.some((tab) => tab.key === tabParam)) return tabParam

    const stored = localStorage.getItem(LS_KEY) ?? 'buffer'
    if (stored === 'personas' || stored === 'agents') return 'followup'
    return TABS.some((tab) => tab.key === stored) ? stored : 'buffer'
  }, [searchParams])

  useEffect(() => {
    fetchInstances().catch(() => undefined)
  }, [fetchInstances])

  useEffect(() => {
    setActiveTab(normalizedInitialTab)
  }, [normalizedInitialTab])

  function handleTabChange(key: string) {
    setActiveTab(key)
    localStorage.setItem(LS_KEY, key)

    const next = new URLSearchParams(searchParams)
    next.set('tab', key)
    next.delete('section')
    setSearchParams(next, { replace: true })
  }

  return (
    <div className="monitoring-page">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-[var(--radius-lg)] bg-[var(--color-brand-light)] text-[var(--color-brand)]">
          <Activity size={20} />
        </div>
        <div>
          <h1 className="text-xl font-bold tracking-tight text-[var(--text-primary)]">Monitoramento</h1>
          <p className="text-xs text-[var(--text-muted)]">
            Hub operacional para follow-up, campanhas e ajustes assistidos.
          </p>
        </div>
      </div>

      <TabNavigation tabs={TABS} activeTab={activeTab} onTabChange={handleTabChange} />

      <div className="monitoring-tab-content">
        {activeTab === 'buffer' && <BufferTab />}
        {activeTab === 'followup' && <FollowUpTab />}
        {activeTab === 'dispatch' && <DispatchTab />}
        {activeTab === 'rcs' && <RcsTab />}
      </div>
    </div>
  )
}
